// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.pagination-container {
  display: flex;
  list-style-type: none;
}
.pagination-container .pagination-item {
  padding: 0 12px;
  height: 32px;
  text-align: center;
  margin: auto 4px;
  color: rgb(50, 151, 107);
  display: flex;
  box-sizing: border-box;
  align-items: center;
  letter-spacing: 0.01071em;
  border-radius: 16px;
  line-height: 18px;
  font-weight: 700;
  font-size: 16px;
  min-width: 32px;
}
.pagination-container .pagination-item.dots:hover {
  background-color: transparent;
  cursor: default;
}
.pagination-container .pagination-item:hover {
  background-color: rgba(50, 151, 107, 0.09);
  cursor: pointer;
}
.pagination-container .pagination-item.selected {
  background-color: rgb(50, 151, 107);
  color: white;
}
.pagination-container .pagination-item .arrow::before {
  position: relative;
  /* top: 3pt; Uncomment this to lower the icons as requested in comments*/
  content: "";
  /* By using an em scale, the arrows will size with the font */
  display: inline-block;
  width: 0.4em;
  height: 0.4em;
  border-right: 0.12em solid rgb(50, 151, 107);
  border-top: 0.12em solid rgb(50, 151, 107);
}
.pagination-container .pagination-item .arrow.left {
  transform: rotate(-135deg) translate(-50%);
}
.pagination-container .pagination-item .arrow.right {
  transform: rotate(45deg);
}
.pagination-container .pagination-item.disabled {
  pointer-events: none;
}
.pagination-container .pagination-item.disabled .arrow::before {
  border-right: 0.12em solid rgba(0, 0, 0, 0.43);
  border-top: 0.12em solid rgba(0, 0, 0, 0.43);
}
.pagination-container .pagination-item.disabled:hover {
  background-color: transparent;
  cursor: default;
}
@media (max-width: 991px) {
  .pagination-container .pagination-item {
    padding: 0 10px;
    height: 30px;
    font-size: 14px;
    min-width: 29px;
  }
}
@media (max-width: 800px) {
  .pagination-container .pagination-item {
    padding: 0 9px;
    height: 25px;
    font-size: 12px;
    min-width: 25px;
  }
}`, "",{"version":3,"sources":["webpack://./src/app/components/Pagination/pagination.scss"],"names":[],"mappings":"AAAA;EACE,aAAA;EAEA,qBAAA;AAAF;AAEE;EACE,eAAA;EACA,YAAA;EACA,kBAAA;EACA,gBAAA;EACA,wBAAA;EACA,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,yBAAA;EACA,mBAAA;EACA,iBAAA;EACA,gBAAA;EACA,eAAA;EACA,eAAA;AAAJ;AAEI;EACE,6BAAA;EACA,eAAA;AAAN;AAEI;EACE,0CAAA;EACA,eAAA;AAAN;AAGI;EACE,mCAAA;EACA,YAAA;AADN;AAKM;EACE,kBAAA;EACA,wEAAA;EACA,WAAA;EACA,6DAAA;EACA,qBAAA;EACA,YAAA;EACA,aAAA;EACA,4CAAA;EACA,0CAAA;AAHR;AAMM;EACE,0CAAA;AAJR;AAOM;EACE,wBAAA;AALR;AASI;EACE,oBAAA;AAPN;AASM;EACE,8CAAA;EACA,4CAAA;AAPR;AAUM;EACE,6BAAA;EACA,eAAA;AARR;AAaE;EACE;IACE,eAAA;IACA,YAAA;IACA,eAAA;IACA,eAAA;EAXJ;AACF;AAcE;EACE;IACE,cAAA;IACA,YAAA;IACA,eAAA;IACA,eAAA;EAZJ;AACF","sourcesContent":[".pagination-container {\n  display: flex;\n\n  list-style-type: none;\n\n  .pagination-item {\n    padding: 0 12px;\n    height: 32px;\n    text-align: center;\n    margin: auto 4px;\n    color: rgba(50, 151, 107, 1);\n    display: flex;\n    box-sizing: border-box;\n    align-items: center;\n    letter-spacing: 0.01071em;\n    border-radius: 16px;\n    line-height: 18px;\n    font-weight: 700;\n    font-size: 16px;\n    min-width: 32px;\n\n    &.dots:hover {\n      background-color: transparent;\n      cursor: default;\n    }\n    &:hover {\n      background-color: rgba(50, 151, 107, 0.09);\n      cursor: pointer;\n    }\n\n    &.selected {\n      background-color: rgba(50, 151, 107, 1);\n      color: white;\n    }\n\n    .arrow {\n      &::before {\n        position: relative;\n        /* top: 3pt; Uncomment this to lower the icons as requested in comments*/\n        content: \"\";\n        /* By using an em scale, the arrows will size with the font */\n        display: inline-block;\n        width: 0.4em;\n        height: 0.4em;\n        border-right: 0.12em solid rgba(50, 151, 107, 1);\n        border-top: 0.12em solid rgba(50, 151, 107, 1);\n      }\n\n      &.left {\n        transform: rotate(-135deg) translate(-50%);\n      }\n\n      &.right {\n        transform: rotate(45deg);\n      }\n    }\n\n    &.disabled {\n      pointer-events: none;\n\n      .arrow::before {\n        border-right: 0.12em solid rgba(0, 0, 0, 0.43);\n        border-top: 0.12em solid rgba(0, 0, 0, 0.43);\n      }\n\n      &:hover {\n        background-color: transparent;\n        cursor: default;\n      }\n    }\n  }\n\n  @media (max-width: 991px) {\n    .pagination-item {\n      padding: 0 10px;\n      height: 30px;\n      font-size: 14px;\n      min-width: 29px;\n    }\n  }\n\n  @media (max-width: 800px) {\n    .pagination-item {\n      padding: 0 9px;\n      height: 25px;\n      font-size: 12px;\n      min-width: 25px;\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
